module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_photowedding@3x-40e267fcf188d07571a905ad0d479e74.webp";